<template>
  <header>
    <div class="header">
      <div class="avatar" v-if="isRoot">
        <img src="../assets/images/avatar.svg" alt="" />
        <h4 v-if="user">Hi {{ user.name }}!</h4>
      </div>

      <div class="back_arrow" v-if="!isRoot">
        <router-link to="/">
          <span class="material-symbols-outlined"> arrow_back_ios_new </span>
        </router-link>
      </div>

      <cookie-timer></cookie-timer>
    </div>
    <div class="menu" v-if="isRoot">
      <a
        class="all"
        href="javascript:void(0)"
        @click.prevent="setActiveFilter('all')"
      >
        <img :src="allImage" alt="" />
        <h4>All</h4>
      </a>
      <a
        class="recommend"
        href="javascript:void(0)"
        @click.prevent="setActiveFilter('recommend')"
      >
        <img :src="recommendImage" alt="" />
        <h4>Recommended</h4>
      </a>
      <a
        class="like"
        href="javascript:void(0)"
        @click.prevent="setActiveFilter('like')"
      >
        <img :src="likeImage" alt="" />
        <h4>Like</h4>
      </a>
    </div>
  </header>
</template>
<script>
import CookieTimer from "@/components/CookieTimer.vue";

// import { fetchUser } from "@/api/user";
export default {
  components: {
    CookieTimer,
  },
  data() {
    return {
      activeFilter: "all",
      // user: null,
    };
  },
  computed: {
    isRoot() {
      return this.$route.path === "/";
    },
    user() {
      return this.$store.state.user;
    },
    allImage() {
      return this.activeFilter === "all"
        ? require("@/assets/images/all_click.svg")
        : require("@/assets/images/all_original.svg");
    },
    recommendImage() {
      return this.activeFilter === "recommend"
        ? require("@/assets/images/recommend_click.svg")
        : require("@/assets/images/recommend_original.svg");
    },
    likeImage() {
      return this.activeFilter === "like"
        ? require("@/assets/images/like_click.svg")
        : require("@/assets/images/like_original.svg");
    },
  },
  mounted() {
    // fetchUser().then((data) => {
    //   this.user = data;
    // });
  },
  methods: {
    setActiveFilter(filter) {
      this.activeFilter = filter;
      this.$emit("filter-changed", filter);
    },
  },
};
</script>

<style>
/* --------------------- header ---------------------*/
header {
  z-index: 13;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  background-color: #f9f9f9;
  width: 100%;
}

.avatar,
.cookie {
  width: auto;
  height: 70px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
}

.cookie {
  padding-right: 10px;
}

.avatar img,
.cookie img {
  height: 53px;
  margin-left: 8px;
}

.back_arrow {
  margin-top: 25px;
}

/* --------------------- menu --------------------- */

.menu {
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 10px 0;
  background-color: #fff;
}

.all,
.recommend,
.like {
  width: 100px;
}

.menu h4 {
  margin-top: 0;
}

.all h4:hover {
  color: #49c4b6;
}

.recommend h4:hover {
  color: #eba915;
}

.like h4:hover {
  color: #ff9298;
}
</style>